<template>
  <v-container fluid>
    <v-layout column>
      <v-flex xs12>
        <h1 class="display-2 font-weight-bold mb-3">{{ $t('welcome') }}</h1>
        <p>{{ $t('info') }}</p>
        <hr style="margin: 1rem 0;">
      </v-flex>

<!--
      <v-flex xs12>
        <h2>О присуждении ППС дополнительных баллов:</h2>
        <ol>
          <li>При подготовке представлений на присуждение ППС дополнительных баллов <b>заведующие кафедрами и директора
            институтов подают проект представления в рейтинговую комиссию <u>института</u></b>.
          </li>
          <li>Рейтинговая комиссия института проверяет достоверность представленной информации.<br/><i>Рекомендованные
            представления подписываются председателем рейтинговой комиссии института и вносящим представление
            руководителем, <b>после чего передаются в рейтинговую комиссию университета</b>.</i></li>
          <li>При выявлении рейтинговой комиссией университета представлений, содержащих недостоверные и/или дублирующие
            пункты Приложения А данные, на лиц, подписавших представление, накладываются штрафные баллы (заявленные
            баллы, поделенные на количество подписавших представление).
          </li>
        </ol>
      </v-flex>

      <v-flex xs12>
        <h2>О присуждении кафедре дополнительных баллов:</h2>
        <ol>
          <li>Директор института может представить на рассмотрение рейтинговой комиссии университета мотивированное
            представление о присуждении кафедре дополнительных баллов за выполнение определенных видов работы, не
            отраженных в Приложении Б положения П051-2021.
          </li>
          <li>При подготовке представлений на присуждение дополнительных баллов <b>проект представления подается в
            рейтинговую комиссию <u>института</u></b>, которая проверяет достоверность представленной информации. <i>Рекомендованные
            представления подписываются председателем рейтинговой комиссии института и директором института, <b>после
              чего передаются в рейтинговую комиссию университета</b>.</i></li>
          <li>При выявлении рейтинговой комиссией университета представлений, содержащих недостоверные и/или дублирующие
            пункты Приложения Б данные, на лиц, подписавших представление, накладываются штрафные баллы в количестве,
            равном заявленному в представлении.
          </li>
        </ol>
      </v-flex>

      <v-flex xs12>
        <hr style="margin: 1rem 0;">
        <p>Документы по рейтингу, представленные после 25 июня, к рассмотрению в текущем учебном году не принимаются.
          <i>Подтверждающие документы по критериям рейтинга, полученные после 25 июня, являются основанием для включения
            рейтинговых баллов в рейтинг ППС следующего учебного года.</i></p>
      </v-flex>

      <v-flex xs12>
        <hr style="margin: 1rem 0;">

        <h4>Контакты проверяющих</h4>

        <v-data-table :headers="headers" :items="contacts" :hide-actions="true" item-key="code"
                      no-data-text="Список пуст">
          <template #items="{ item }">
            <td>{{ item.number }}</td>
            <td v-html="item.indicator" />
            <td v-html="item.fio" />
            <td v-html="item.contact" style="white-space: nowrap;" />
          </template>
        </v-data-table>
      </v-flex>
-->
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    headers: [{
      text: '',
      align: 'left',
      sortable: false,
      value: 'number'
    }, {
      text: 'Индикатор',
      align: 'left',
      sortable: false,
      value: 'indicator'
    }, {
      text: 'ФИО проверяющего',
      align: 'left',
      sortable: false,
      value: 'fio'
    }, {
      text: 'Контакты',
      align: 'left',
      sortable: false,
      value: 'contact'
    }],
    contacts: [{
      code: "code-2",
      number: "1.1",
      indicator: "Издание учебников с грифом МОН РК.",
      fio: "Исмаилова Г.С.",
      contact: "8 705 902 6168",
    },
      {
        code: "code-3",
        number: "1.10",
        indicator: "Разработка и внедрение курса на платформах массовых открытых он-лайн курсов",
        fio: "Тастанова Г.Т.",
        contact: "51-16-44<br /> 8(747)-308-29-44",
      },
      {
        code: "code-4",
        number: "1.11",
        indicator: "Наличие сертификата об успешном прохождении обучения по курсу на базе платформы массовых открытых онлайн курсов по профессиональной деятельности (на базе платформ Coursera, EdX, Udacity, FutureLearn)",
        fio: "Жакаева Г.Е.",
        contact: "8 (7142) 39-06-30",
      },
      {
        code: "code-5",
        number: "1.12",
        indicator: "Обучение на курсах английского языка:",
        fio: "",
        contact: "",
      },
      {
        code: "code-6",
        number: "1.12",
        indicator: "1) продвинутый уровень;",
        fio: "Абишева С.К.<br /> Жакаева Г.Е.",
        contact: "8 701 584 8135<br /> 8 (7142) 39-06-30",
      },
      {
        code: "code-7",
        number: "1.13",
        indicator: "Участие в проекте «Корпоративное обучение»:",
        fio: "",
        contact: "",
      },
      {
        code: "code-8",
        number: "1.13",
        indicator: "1) в качестве руководителя программы;",
        fio: "Жакаева Г.Е.",
        contact: "8 (7142) 39-06-30",
      },
      {
        code: "code-9",
        number: "1.13",
        indicator: "2) разработка и проведение инновационного курса;",
        fio: "Жакаева Г.Е.",
        contact: "8 (7142) 39-06-30",
      },
      {
        code: "code-10",
        number: "1.13",
        indicator: "3) в качестве лектора (1 занятие)",
        fio: "Жакаева Г.Е.",
        contact: "8 (7142) 39-06-30",
      },
      {
        code: "code-11",
        number: "1.14",
        indicator: "Оказание образовательных услуг с перечислением средств на счет университета, в том числе проведение специализированных курсов для сторонних организаций, сотрудников КРУ и других лиц",
        fio: "Жакаева Г.Е.",
        contact: "8 (7142) 39-06-30",
      },
      {
        code: "code-12",
        number: "1.15",
        indicator: "Получение сертификата TOEFL, IELTS, FCE, CAE, TKT, ICELT, CELTA, DELTA, TESOL, Goethe-Zertifikat, DELF, DALF, TFI, TCF, DSH, TestDaF, DET, CEFR",
        fio: "Абишева С.К.",
        contact: "87015848135",
      },
      {
        code: "code-13",
        number: "1.16",
        indicator: "Преподавание неязыковых дисциплин на английском языке",
        fio: "Абишева С.К.",
        contact: "87015848135",
      },
      {
        code: "code-14",
        number: "1.2",
        indicator: "Рекомендация к изданию учебников, учебных пособий УМО РУМС базового вуза.",
        fio: "Исмаилова Г.С.",
        contact: "8 705 902 6168",
      },
      {
        code: "code-15",
        number: "1.20",
        indicator: "Участие в конкурсе «Лучший преподаватель вуза»:",
        fio: "",
        contact: "",
      },
      {
        code: "code-16",
        number: "1.20",
        indicator: "3) рекомендация к участию в республиканском этапе;",
        fio: "Абенова Ж.М.",
        contact: "What'sApp +7 926 965-17-27<br /> 8 707 370 62 21",
      },
      {
        code: "code-17",
        number: "1.20",
        indicator: "4) победа в республиканском этапе.",
        fio: "Абенова Ж.М.",
        contact: "What'sApp +7 926 965-17-27<br /> 8 707 370 62 21",
      },
      {
        code: "code-18",
        number: "1.21",
        indicator: "Призовое место в конкурсе:",
        fio: "",
        contact: "",
      },
      {
        code: "code-19",
        number: "1.21",
        indicator: "1) Лучший молодой преподаватель (1,2,3 место)",
        fio: "Айткужинова С.Н.",
        contact: "87054563623",
      },
      {
        code: "code-20",
        number: "1.22",
        indicator: "2) Лучшая лекция, лучшее практическое занятие (1,2,3 место)",
        fio: "Айткужинова С.Н.",
        contact: "87054563623",
      },
      {
        code: "code-21",
        number: "1.3",
        indicator: "Издание учебных и учебно-методических пособий, утвержденных УМС университета (с ISBN), с обязательным их размещением в электронной библиотеке университета:",
        fio: "",
        contact: "",
      },
      {
        code: "code-22",
        number: "1.3",
        indicator: "1) на казахском, русском, иностранном языках;",
        fio: "Саканова Б.Н.",
        contact: "511141",
      },
      {
        code: "code-23",
        number: "1.4",
        indicator: "Разработка электронного учебного издания (в том числе комплекс виртуальных лабораторных работ и моделирующих программ), утвержденного УМС университета.",
        fio: "Сатмагамбетова Ж.З.",
        contact: "55-84-62",
      },
      {
        code: "code-24",
        number: "1.5",
        indicator: "Разработка видеолекций по дисциплинам.",
        fio: "Сатмагамбетова Ж.З.",
        contact: "55-84-62",
      },
      {
        code: "code-25",
        number: "1.6",
        indicator: "Формирование УМКД в первый год (по новым дисциплинам, которых не было в учебном плане ранее) на английском языке (по неязыковым дисциплинам) по естественно-математическому циклу",
        fio: "Сейткасимова Д.С.",
        contact: "511144",
      },
      {
        code: "code-26",
        number: "1.7",
        indicator: "Профессиональная переподготовка, повышение квалификации в организациях образования, научно-исследовательских организациях, организациях дополнительного образования по общепедагогическому направлению",
        fio: "Жакаева Г.Е.",
        contact: "8 (7142) 39-06-30",
      },
      {
        code: "code-27",
        number: "1.9",
        indicator: "Работа в системе дистанционного обучения Moodle:",
        fio: "",
        contact: "",
      },
      {
        code: "code-28",
        number: "1.9",
        indicator: "1) разработка автоматизированного теста с вопросами разного типа (не менее 100 вопросов, не менее 7 типов вопросов);",
        fio: "Тастанова Г.Т.",
        contact: "51-16-44<br /> 8(747)-308-29-44",
      },
      {
        code: "code-29",
        number: "1.9",
        indicator: "2) разработка интерактивной лекции /практического занятия (не менее 7 информационных страниц, не менее 20 вопросов);",
        fio: "Тастанова Г.Т.",
        contact: "51-16-44<br /> 8(747)-308-29-44",
      },
      {
        code: "code-30",
        number: "1.9",
        indicator: "3) разработка 1 элемента: Hot Potatoes (не менее 10 слов) / Глоссарий курса (25- 30 определений) / Активный элемент Задание;",
        fio: "Тастанова Г.Т.",
        contact: "51-16-44<br /> 8(747)-308-29-44",
      },
      {
        code: "code-31",
        number: "1.9",
        indicator: "4) разработка дистанционных олимпиад для старшеклассников и выпускников колледжей (на платформе дистанционного обучения университета).",
        fio: "Тастанова Г.Т.",
        contact: "51-16-44<br /> 8(747)-308-29-44",
      },
      {
        code: "code-32",
        number: "2.10",
        indicator: "Подготовка студентов-разработчиков бизнес-проектов, эссе, стартапов:",
        fio: "",
        contact: "",
      },
      {
        code: "code-33",
        number: "2.10",
        indicator: "1) стартап с регистрацией бизнеса, подтверждённый созданием рабочих мест и налоговыми отчислениями;",
        fio: "Дамбаулова Г.К.",
        contact: "8 701 556 0668",
      },
      {
        code: "code-34",
        number: "2.10",
        indicator: "2) выигравшие гранты (финансирование);",
        fio: "Дамбаулова Г.К.",
        contact: "8 701 556 0668",
      },
      {
        code: "code-35",
        number: "2.12",
        indicator: "Получение:",
        fio: "",
        contact: "",
      },
      {
        code: "code-36",
        number: "2.12",
        indicator: "1) патента;",
        fio: "Айтжанова И.Н.",
        contact: "8 702 797 2638",
      },
      {
        code: "code-37",
        number: "2.12",
        indicator: "2) свидетельства интеллектуальной собственности;",
        fio: "Айтжанова И.Н.",
        contact: "8 702 797 2638",
      },
      {
        code: "code-38",
        number: "2.12",
        indicator: "3) свидетельство интеллектуальной собственности на ЭУИ;",
        fio: "Айтжанова И.Н.",
        contact: "8 702 797 2638",
      },
      {
        code: "code-39",
        number: "2.12",
        indicator: "4) публикации патентов в патентной базе Derwent Innovations Index компании Creative Analytics.",
        fio: "Ержанова Ж.С.",
        contact: "55-79-29<br /> 8-777-972-48-37",
      },
      {
        code: "code-40",
        number: "2.13",
        indicator: "Издание монографии с ISBN.",
        fio: "Безаубекова С.С.",
        contact: "8 707 508 4088",
      },
      {
        code: "code-41",
        number: "2.14",
        indicator: "Публикация научных статей в научных изданиях:",
        fio: "",
        contact: "",
      },
      {
        code: "code-42",
        number: "2.14",
        indicator: "1) индексируемых в Web of Science, Thomson Reuters, Scopus;",
        fio: "ИТИ и СХИ - Ержанова Ж. С.<br /> <br /> ИЭиП и ПИ - Безаубекова С.С.",
        contact: "55-79-29<br /> 8-777-972-48-37<br /> 8 707 508 4088",
      },
      {
        code: "code-43",
        number: "2.14",
        indicator: "2) индексируемых в Pubmed, zbMath, MathScinet, Agris, Georef, Astrophysical journal;",
        fio: "ИТИ и СХИ - Ержанова Ж. С.<br /> <br /> ИЭиП и ПИ - Безаубекова С.С.",
        contact: "55-79-29<br /> 8-777-972-48-37<br /> 8 707 508 4088",
      },
      {
        code: "code-44",
        number: "2.14",
        indicator: "3) в журналах, рекомендованных КОКСО МОН РК;",
        fio: "Сатбаева М. Т.",
        contact: "54-58-74 (вн. 229)",
      },
      {
        code: "code-45",
        number: "2.14",
        indicator: "4) в журналах, рекомендованных ВАК России, Белоруссии, Кыргызстана;",
        fio: "Сатбаева М. Т.",
        contact: "54-58-74 (вн. 229)",
      },
      {
        code: "code-46",
        number: "2.14",
        indicator: "6) в журнале «3i», «Вестник КГПИ»",
        fio: "Сатбаева М. Т.",
        contact: "54-58-74 (вн. 229)",
      },
      {
        code: "code-47",
        number: "2.14",
        indicator: "7) Совместная публикация в журнале «3i», Вестник КГПИ с иностранным ученым;",
        fio: "Сатбаева М. Т.",
        contact: "54-58-74 (вн. 229)",
      },
      {
        code: "code-48",
        number: "2.15",
        indicator: "Оценка публикационной активности ППС h-индекс (индекс Хирша):",
        fio: "",
        contact: "",
      },
      {
        code: "code-49",
        number: "2.15",
        indicator: "1) Web of Science и Scopus;",
        fio: "ИТИ и СХИ - Ержанова Ж. С.<br /> <br /> ИЭиП и ПИ - Безаубекова С.С.",
        contact: "55-79-29<br /> 8-777-972-48-37<br /> 8 707 508 4088",
      },
      {
        code: "code-50",
        number: "2.15",
        indicator: "2) Elibrary, РИНЦ.",
        fio: "ИТИ и СХИ - Ержанова Ж. С.<br /> <br /> ИЭиП и ПИ - Безаубекова С.С.",
        contact: "55-79-29<br /> 8-777-972-48-37<br /> 8 707 508 4088",
      },
      {
        code: "code-51",
        number: "2.17",
        indicator: "Участие в международных научных конференциях с выездом ППС и обучающихся:",
        fio: "",
        contact: "",
      },
      {
        code: "code-52",
        number: "2.17",
        indicator: "2) в странах ЕврАзЭС;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-53",
        number: "2.17",
        indicator: "3) в зарубежье.",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-54",
        number: "2.18",
        indicator: "Участие в конкурсах международных проектов:",
        fio: "",
        contact: "",
      },
      {
        code: "code-55",
        number: "2.18",
        indicator: "1) выигравших грантовое финансирование;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-56",
        number: "2.2",
        indicator: "Получение в течение учебного года ученого звания или судейской категории:",
        fio: "",
        contact: "",
      },
      {
        code: "code-57",
        number: "2.2",
        indicator: "1) профессора КОКСОН / судьи Международной категории;",
        fio: "Смагина О.А. <br /> Дюсекова Г.А.",
        contact: "8 (7142) 51-10-25<br /> 8 705 462 39 01",
      },
      {
        code: "code-58",
        number: "2.2",
        indicator: "2) ассоциированного профессора (доцента) КОКСОН / судьи Высшей национальной категории.",
        fio: "Смагина О.А. <br /> Дюсекова Г.А.",
        contact: "8 (7142) 51-10-25<br /> 8 705 462 39 01",
      },
      {
        code: "code-59",
        number: "2.20",
        indicator: "Зарубежная мобильность:",
        fio: "",
        contact: "",
      },
      {
        code: "code-60",
        number: "2.20",
        indicator: "1) командировка в образовательные и научные учреждения (длительность до 5 дней);",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-61",
        number: "2.20",
        indicator: "2) стажировка в зарубежных образовательных и научных организациях с получением сертификата или подтверждающего письма зарубежной организации;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-62",
        number: "2.20",
        indicator: "3) преподавание дисциплины в рамках виртуальной мобильности;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-63",
        number: "2.20",
        indicator: "4) совместная работа с зарубежным преподавателем;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-64",
        number: "2.20",
        indicator: "5) подача документов для участия в программе «Болашак».",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-65",
        number: "2.3",
        indicator: "Получение в течение учебного года ученой степени:",
        fio: "",
        contact: "",
      },
      {
        code: "code-66",
        number: "2.3",
        indicator: "1) доктора PhD;",
        fio: "Смагина О.А. <br /> Дюсекова Г.А.",
        contact: "8 (7142) 51-10-25<br /> 8 705 462 39 01",
      },
      {
        code: "code-67",
        number: "2.3",
        indicator: "2) заслуженный деятель искусства РК;",
        fio: "Смагина О.А. <br /> Дюсекова Г.А.",
        contact: "8 (7142) 51-10-25<br /> 8 705 462 39 01",
      },
      {
        code: "code-68",
        number: "2.3",
        indicator: "3) заслуженного тренера РК.",
        fio: "Смагина О.А. <br /> Дюсекова Г.А.",
        contact: "8 (7142) 51-10-25<br /> 8 705 462 39 01",
      },
      {
        code: "code-69",
        number: "2.4",
        indicator: "Рецензирование:",
        fio: "",
        contact: "",
      },
      {
        code: "code-70",
        number: "2.4",
        indicator: "1) статей в журнал «3i: intellect, idea, innovation – интеллект, идея, инновация»",
        fio: "Шалгимбекова К.С.",
        contact: "8 707 663 5801",
      },
      {
        code: "code-71",
        number: "2.5",
        indicator: "Участие в конкурсах научных проектов с финансированием:",
        fio: "",
        contact: "",
      },
      {
        code: "code-72",
        number: "2.5",
        indicator: "1) выигравшие финансирование;",
        fio: "Бугубаева А.У.<br /> Досмухамедова З.Ж.",
        contact: "8 747 966 6571<br /> 53 34 71",
      },
      {
        code: "code-73",
        number: "2.6",
        indicator: "Разработка темы НИР (кроме грантовых научных проектов МОН), зарегистрированной в НЦГНТЭ.",
        fio: "Айтжанова И.Н.",
        contact: "8 702 797 2638",
      },
      {
        code: "code-74",
        number: "2.7",
        indicator: "Государственно-частное партнерство с финансированием – за каждые 100 тыс. тенге, поступивших на счет университета по хоздоговору.",
        fio: "Нургалиева Р.К.",
        contact: "Педагогический корпус, каб 112 <br /> 54 58 74 (вн. 162)",
      },
      {
        code: "code-75",
        number: "2.8",
        indicator: "Подготовка победителей конкурсов НИРС (НИРМ), предметных олимпиад (в том числе музыкальных фестивалей и т.д. в соответствии со спецификой ОП) (1, 2, 3 место в личных или общекомандных соревнованиях):",
        fio: "",
        contact: "",
      },
      {
        code: "code-76",
        number: "2.8",
        indicator: "1) республиканских МОН РК;",
        fio: "Кажиякбарова А. Т.",
        contact: "8 747 016 9355",
      },
      {
        code: "code-77",
        number: "2.8",
        indicator: "2) республиканских МОН РК (для школьников);",
        fio: "Кажиякбарова А. Т.",
        contact: "8 747 016 9355",
      },
      {
        code: "code-78",
        number: "2.8",
        indicator: "4) международных:",
        fio: "",
        contact: "",
      },
      {
        code: "code-79",
        number: "2.8",
        indicator: "4.1) в РК:",
        fio: "",
        contact: "",
      },
      {
        code: "code-80",
        number: "2.8",
        indicator: "4.1.1) очное участие республиканского уровня;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-81",
        number: "2.8",
        indicator: "4.1.2) очное участие регионального уровня;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-82",
        number: "2.8",
        indicator: "4.1.3) дистанционное участие республиканского уровня;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-83",
        number: "2.8",
        indicator: "4.1.4) дистанционное участие регионального уровня;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-84",
        number: "2.8",
        indicator: "4.2) ближнее зарубежье:",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-85",
        number: "2.8",
        indicator: "4.2.1) очное участие вузы партнеры;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-86",
        number: "2.8",
        indicator: "4.2.2) очное участие другие вузы и образовательные организации;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-87",
        number: "2.8",
        indicator: "4.2.1) дистанционное участие вузы партнеры;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-88",
        number: "2.8",
        indicator: "4.2.2) дистанционное участие другие вузы и образовательные организации;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-89",
        number: "2.8",
        indicator: "4.3) дальнее зарубежье.",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-90",
        number: "2.9",
        indicator: "Внедрение результатов НИР ППС:",
        fio: "",
        contact: "",
      },
      {
        code: "code-91",
        number: "2.9",
        indicator: "1) внедрение патента в производство (бизнес) с оплатой на счет университета от 50 тысяч тенге;",
        fio: "Айтжанова И.Н.",
        contact: "8 702 797 2638",
      },
      {
        code: "code-92",
        number: "3.10",
        indicator: "Работа в качестве руководителя команды обучающихся от университета, в качестве члена жюри в конкурсах, спортивных соревнованиях.",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-93",
        number: "3.3",
        indicator: "Организация и проведение воспитательных мероприятий:",
        fio: "",
        contact: "",
      },
      {
        code: "code-94",
        number: "3.3",
        indicator: "1) международного уровня;",
        fio: "Беркенова Г.С.",
        contact: "8 (7142) 55-85-19",
      },
      {
        code: "code-95",
        number: "3.3",
        indicator: "2) республиканского уровня;",
        fio: "Беркенова Г.С.",
        contact: "8 (7142) 55-85-19",
      },
      {
        code: "code-96",
        number: "3.3",
        indicator: "3) университетского уровня;",
        fio: "Беркенова Г.С.",
        contact: "8 (7142) 55-85-19",
      },
      {
        code: "code-97",
        number: "3.3",
        indicator: "4) институтский уровень;",
        fio: "СХИ Кобжасаров Т.Ж.<br />ИТИ Есимханов Қ.Д.<br />ИЭиП Ракпанова Д.Б.<br />ПИ Ахметчина Т.А.<br /> ЦЯП - Журсиналина Г.К.",
        contact: "ИЭиП - 8 (7142) 51-11-53<br /> ИТИ - 8 (7142) 55-85-17<br /> СХИ - 8 (7142) 55-84-63<br /> ПИ - 8 (7142) 53-04-55",
      },
      {
        code: "code-98",
        number: "3.3",
        indicator: "5) кафедрального уровня.",
        fio: "СХИ Кобжасаров Т.Ж.<br />ИТИ Есимханов Қ.Д.<br />ИЭиП Ракпанова Д.Б.<br />ПИ Ахметчина Т.А.<br /> ЦЯП - Журсиналина Г.К.",
        contact: "ИЭиП - 8 (7142) 51-11-53<br /> ИТИ - 8 (7142) 55-85-17<br /> СХИ - 8 (7142) 55-84-63<br /> ПИ - 8 (7142) 53-04-55",
      },
      {
        code: "code-99",
        number: "3.4",
        indicator: "Призовое место в конкурсе:",
        fio: "",
        contact: "",
      },
      {
        code: "code-100",
        number: "3.4",
        indicator: "1) Лучший куратор института (1,2,3 место);",
        fio: "Беркенова Г.С.",
        contact: "8 (7142) 55-85-19",
      },
      {
        code: "code-101",
        number: "3.4",
        indicator: "2) Лучший куратор университета (1,2,3 место).",
        fio: "Беркенова Г.С.",
        contact: "8 (7142) 55-85-19",
      },
      {
        code: "code-102",
        number: "3.7",
        indicator: "Подготовка победителей спортивных соревнований (1, 2, 3 место в личных или общекомандных соревнованиях):",
        fio: "",
        contact: "",
      },
      {
        code: "code-103",
        number: "3.7",
        indicator: "1) международных (зарубежных);",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-104",
        number: "3.7",
        indicator: "2) международных (в РК);",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-105",
        number: "3.7",
        indicator: "3) республиканские;",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-106",
        number: "3.7",
        indicator: "4) областных;",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-107",
        number: "3.7",
        indicator: "5) городских.",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-108",
        number: "3.8",
        indicator: "Подготовка мастера спорта:",
        fio: "",
        contact: "",
      },
      {
        code: "code-109",
        number: "3.8",
        indicator: "1) международного класса;",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-110",
        number: "3.8",
        indicator: "2) мастера спорта РК;",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-111",
        number: "3.8",
        indicator: "3) кандидата в мастера спорта (первый взрослый разряд по игровым видам).",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-112",
        number: "3.9",
        indicator: "Проведение спортивного соревнования:",
        fio: "",
        contact: "",
      },
      {
        code: "code-113",
        number: "3.9",
        indicator: "1) международного уровня;",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-114",
        number: "3.9",
        indicator: "2) республиканского уровня;",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-115",
        number: "3.9",
        indicator: "3) областного, городского и университетского уровня;",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-116",
        number: "3.9",
        indicator: "4) на уровне института, кафедры.",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-117",
        number: "4.1",
        indicator: "Организация и проведение мероприятий по обсуждению образовательных программ, трудоустройству, организации практик и конкурсов «Лучший по профессии» с участием работодателей и выпускников.",
        fio: "Исмаилова Г.С.<br /> Жумангузова Н.А.",
        contact: "8 705 902 6168<br /> 8 775 520 1435",
      },
      {
        code: "code-118",
        number: "4.2",
        indicator: "Участие в работе:",
        fio: "",
        contact: "",
      },
      {
        code: "code-119",
        number: "4.2",
        indicator: "2) председатель рейтинговой комиссии института.",
        fio: "Абенова Ж.М.",
        contact: "What'sApp +7 926 965-17-27<br /> 8 707 370 62 21",
      },
      {
        code: "code-120",
        number: "4.3",
        indicator: "Выполнение общественных поручений:",
        fio: "",
        contact: "ИЭиП - 8 (7142) 51-11-53<br /> ИТИ - 8 (7142) 55-85-17<br /> СХИ - 8 (7142) 55-84-63<br /> ПИ - 8 (7142) 53-04-55",
      },
      {
        code: "code-121",
        number: "4.3",
        indicator: "1) ответственный за учебно-методическую работу, в т.ч. председатель МС института;",
        fio: "Чехова Т. И.<br /> Саметова Г.С.<br /> Бижанова О. И.<br /> Мұратқызы М.<br /> Журсиналина Г.К.",
        contact: "ИЭиП - 8 (7142) 51-11-53<br /> ИТИ - 8 (7142) 55-85-17<br /> СХИ - 8 (7142) 55-84-63<br /> ПИ - 8 (7142) 53-04-55",
      },
      {
        code: "code-122",
        number: "4.3",
        indicator: "2) ответственный за научную работу;",
        fio: "Васильчук Е.В.<br /> Ибрагимова С. В.<br /> Есментаева <br /> Журсиналина Г.К.",
        contact: "ИЭиП - 8 (7142) 51-11-53<br /> ИТИ - 8 (7142) 55-85-17<br /> СХИ - 8 (7142) 55-84-63<br /> ПИ - 8 (7142) 53-04-55",
      },
      {
        code: "code-123",
        number: "4.3",
        indicator: "4) ответственный за воспитательную работу;",
        fio: "Кобжасаров Т.Ж.<br /> Ракпанова Д.Б.<br /> Есимханов Қ. Д.<br /> Ахметчина Т.А.<br /> Журсиналина Г.К.",
        contact: "ИЭиП - 8 (7142) 51-11-53<br /> ИТИ - 8 (7142) 55-85-17<br /> СХИ - 8 (7142) 55-84-63<br /> ПИ - 8 (7142) 53-04-55",
      },
      {
        code: "code-124",
        number: "4.3",
        indicator: "ответственный за деятельность спортивного клуба Университета;",
        fio: "Огиенко Н.А.",
        contact: "54 58 74 (внут. 119)",
      },
      {
        code: "code-125",
        number: "4.3",
        indicator: "Выполнение общественных поручений:",
        fio: "",
        contact: "",
      },
      {
        code: "code-126",
        number: "4.3",
        indicator: "ответственный за интернационализацию;",
        fio: "Даулетбай Г. Т.",
        contact: "54-58-74 (вн. 156)",
      },
      {
        code: "code-127",
        number: "4.4",
        indicator: "Выполнение переводов на государственный, русский и иностранные языки:",
        fio: "",
        contact: "",
      },
      {
        code: "code-128",
        number: "4.4",
        indicator: "2) НСД, аккредитационных и рейтинговых документов.",
        fio: "Абенова Ж.М.",
        contact: "What'sApp +7 926 965-17-27<br /> 8 707 370 62 21",
      },
      {
        code: "code-129",
        number: "4.4",
        indicator: "Выполнение переводов на государственный, русский и иностранные языки:",
        fio: "",
        contact: "",
      },
      {
        code: "code-130",
        number: "4.4",
        indicator: "1) научных проектов и статей;",
        fio: "Сатбаева М. Т.",
        contact: "54-58-74 (вн. 229)",
      },
      {
        code: "code-131",
        number: "4.6",
        indicator: "Участие в работе Комитета по учебным планам и программам, разработка ОП и документов:",
        fio: "",
        contact: "",
      },
      {
        code: "code-132",
        number: "4.6",
        indicator: "1) бакалавриат;",
        fio: "Аймуханова К. Т.",
        contact: "511141",
      },
      {
        code: "code-133",
        number: "4.6",
        indicator: "2) магистратура;",
        fio: "Аймуханова К. Т.",
        contact: "511141",
      },
      {
        code: "code-134",
        number: "4.6",
        indicator: "3) докторантура.",
        fio: "Аймуханова К. Т.",
        contact: "511141",
      },
      {
        code: "code-135",
        number: "4.7",
        indicator: "Статьи и выступления в СМИ о деятельности университета.",
        fio: "Устемирова А.С.",
        contact: "8 701 886 0900",
      }],
  })
}
</script>

<i18n>
{
  "ru": {
    "welcome": "Добро пожаловать!",
    "info": "Для заполнения педагогической нагрузки, пожалуйста, выберите слева учебный год."
  },
  "kz": {
    "welcome": "Қош келдіңіз!",
    "info": "Оқу жүктемесін толтыру үшін сол жақтағы оқу жылын таңдаңыз."
  }
}
</i18n>
